import { render, staticRenderFns } from "./downYield.vue?vue&type=template&id=3a3b2485&scoped=true&"
import script from "./downYield.vue?vue&type=script&lang=js&"
export * from "./downYield.vue?vue&type=script&lang=js&"
import style0 from "./downYield.vue?vue&type=style&index=0&id=3a3b2485&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a3b2485",
  null
  
)

export default component.exports